export default "__VITE_ASSET__4da04bb8__"